import { VariantProps, cva } from 'class-variance-authority'
import { ComponentPropsWithRef, forwardRef } from 'react'

import { cn } from '../utils'

const heading1Variants = cva('font-bold tracking-tight', {
  variants: {
    size: {
      sm: 'text-2xl',
      default: 'text-3xl',
    },
  },
  defaultVariants: {
    size: 'default',
  },
})

export const Heading1 = forwardRef<
  HTMLHeadingElement,
  ComponentPropsWithRef<'h1'> & VariantProps<typeof heading1Variants>
>(({ size, ...props }, ref) => (
  <h1
    {...props}
    ref={ref}
    className={heading1Variants({ size, className: props.className })}
  >
    {props.children}
  </h1>
))

export const Heading2 = forwardRef<HTMLHeadingElement, ComponentPropsWithRef<'h1'>>(
  (props, ref) => (
    <h2 {...props} ref={ref} className={cn('text-2xl font-semibold', props.className)}>
      {props.children}
    </h2>
  ),
)

export const Heading3 = forwardRef<HTMLHeadingElement, ComponentPropsWithRef<'h1'>>(
  (props, ref) => (
    <h2 {...props} ref={ref} className={cn('text-xl font-semibold', props.className)}>
      {props.children}
    </h2>
  ),
)
